import { BrandCard } from './buds-header';

export function SyncHowItWorksCard() {
  return (
    <BrandCard title="How product sync works">
      <p className="text-sm leading-relaxed text-buds-dark/80">
        Configure each Shopify product via metafields under the{' '}
        <span className="font-mono">buds</span> namespace. They appear on every
        product detail page once the Buds app is connected. Any metafield left
        blank falls back to the shop&apos;s default above.
      </p>
      <ul className="mt-3 space-y-2 text-sm leading-relaxed text-buds-dark/80">
        <li>
          <span className="font-mono text-buds-dark">buds.sync_enabled</span>{' '}
          (boolean) — in &ldquo;All products&rdquo; scope, set to false to
          exclude a product; in &ldquo;Selected products only&rdquo; scope, set
          to true to include it.
        </li>
        <li>
          <span className="font-mono text-buds-dark">buds.force_sync</span>{' '}
          (boolean) — set to true to sync a product whatever the scope or{' '}
          <span className="font-mono">buds.sync_enabled</span>, including Draft
          and Unlisted products. Draft products sync only with SHOPIFY_ORDER
          mode — a voucher needs the product to be buyable on the storefront.
        </li>
        <li>
          <span className="font-mono text-buds-dark">buds.redemption_mode</span>{' '}
          (SHOPIFY_ORDER or SHOPIFY_VOUCHER) — how Buds fulfils a redemption.
          Falls back to the shop&apos;s default.
        </li>
        <li>
          <span className="font-mono text-buds-dark">buds.points_required</span>{' '}
          (integer) — override the points cost. Defaults to 1 EUR cent per point
          from the product price.
        </li>
        <li>
          <span className="font-mono text-buds-dark">buds.free_shipping</span>{' '}
          (boolean) — for SHOPIFY_VOUCHER rewards: whether the voucher waives
          shipping. Falls back to the shop&apos;s default.
        </li>
      </ul>
      <p className="mt-3 text-xs text-buds-dark/60">
        Only ACTIVE products are synced, unless buds.force_sync is true.
        ARCHIVED products are never synced, and products that leave the sync
        scope are removed from rewards. The first sync is manual; after
        automatic sync is enabled, Shopify product changes are reconciled in the
        background. Sync currently supports shops with EUR or USD as the shop
        currency.
      </p>
    </BrandCard>
  );
}
